import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { StoreHelper } from '../../shared/helpers/store.helper';
declare var $: any;

import Player from "@vimeo/player/dist/player.js";
import { isBeta } from '../../shared/services';
import { ControllerService } from '../../shared/services/controller.service';

@Component({
    selector: 'app-intro-video',
    templateUrl: './intro-video.component.html',
    styleUrls: ['./intro-video.component.scss'],
    standalone: false
})
export class IntroVideoComponent implements OnInit, OnDestroy {



  current: number = 0;
  duration: number = 0;
  progressValue: number = 0;
  underPlay: boolean = false;
  loadedPlay: boolean = false;
  OnCaption: boolean = false;
  videoVimeoId: any;
  lastEvent: any;
  player: any;
  lastUpdated: number = 0;
  updateInterval: number = 1000;
  isBeta: boolean =  isBeta()
  skipToEnd: boolean = false
  disableFullScreen = false

  isReplay = false

  @ViewChild('video', { static: false }) video: any;

  constructor( public controller: ControllerService) {}


  ngOnDestroy(): void {
    $('.main-link').show()
  }

  ngOnInit() {
    $('body').removeClass();

    this.onLoadVideo()

    this.videobgEnlarge();

    $('#video-with-controls').on('fullscreenchange', function(){
      if( (window.document as any).fullscreenElement === null ){
        $("#vimeo_" + this.videoId).attr("height", "300px");
        this.underPlay = false;
        this.player.pause();
      }
    }.bind(this))

    this.player.disableTextTrack();

    this.skipToEnd = StoreHelper.getObject('fastForward')

    this.onPlay()
  }

  onMediaTimeUpdate(data: { seconds: any, percent: any, duration: any }) {
    this.current = data.seconds;
    this.duration = data.duration;
    this.progressValue = data.percent * 100;
    if (this.progressValue > 0) {
      $('body').removeClass('loading');
    }
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove($event) {
    if (this.underPlay) {
      this.lastEvent = new Date().getTime();
      this.fadeInControls();
    }
  }

  fadeOutControls() {
    if (parseInt($(".controls-container").css("opacity")) !== 0) {
      $(".controls-container").css("opacity", 0);
    }
  }

  fadeInControls() {
    if (parseInt($(".controls-container").css("opacity")) !== 1) {
      $(".controls-container").css("opacity", 1);
    }
  }

  onClickProgress(e){
    const target = e.target
    const x = e.pageX - target.offsetLeft, clickedValue = x / target.clientWidth;

    if( clickedValue < target.clientWidth ){

      const newTime = Math.floor( clickedValue * this.current )
      this.player.setCurrentTime( newTime )
      this.onMediaTimeUpdate( {seconds: newTime, duration : this.duration, percent: newTime/ this.duration })

    }
  }

  onMediaEnd() {
    $("#vimeo_" + this.videoVimeoId).attr('height', '300px');

    this.underPlay = false;


    this.onNext();
    $('.main-link').show()
    $("#vimeo_" + this.videoVimeoId)[0].requestFullScreen()
    window.document.exitFullscreen()
  }

  onPlay() {
    $("#vimeo_" + this.videoVimeoId).attr('height', '100%');
    $(".play-next-wrapper").addClass("hide");
    this.player.play()
    this.underPlay = true;
    this.videobgEnlarge();
    setTimeout(this.videobgEnlarge, 10);
    $('.main-link').hide()


    if( !this.disableFullScreen ){
      $("#video-with-controls")[0].requestFullscreen()
    }

    if( this.skipToEnd ){
      this.player.getDuration().then( (duration) => {
        this.player.setCurrentTime(duration - 2 );
      })
    }

  }

  onBackward() {
    if (this.underPlay && (this.current - 5) > 0) {
      this.current -= 5;
      this.player.setCurrentTime(this.current);
    }
  }

  onForward() {
    if (this.underPlay && (this.current + 5) < this.duration) {
      this.current += 5;
      this.player.setCurrentTime(this.current);
    }
  }

  onPause() {
    this.player.pause();
    this.underPlay = false;
    $('.main-link').show()

    window.document.exitFullscreen()

  }

  OnSubtitles() {
    this.player.enableTextTrack('en');
    this.OnCaption = true;
  }

  OffSubtitles() {
    this.player.disableTextTrack();
    this.OnCaption = false;
  }

  onNext() {

    this.controller.next(false, false, true)

  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    var timeoutId;
    clearTimeout(timeoutId);
    timeoutId = setTimeout(this.videobgEnlarge, 10);
  }

  videobgEnlarge() {
    const $videoBgAspect = $('.fullScreen .videobg-aspect');
    const $videoBgWidth = $('.fullScreen .videobg-width');
    const $controlContainer = $('.fullScreen .videobg-width .controls-container');
    const videoAspect = $videoBgAspect.outerHeight() / $videoBgAspect.outerWidth();
    const windowAspect = ($(window).height() / $(window).width());
    const calculated = 100 * (videoAspect - (windowAspect - 0.06));
    $controlContainer.css('bottom', Math.max(calculated, 10) + '%');

    if (windowAspect > videoAspect) {
      const calcuationWith = (windowAspect / videoAspect) * 100;
      $videoBgWidth.width(calcuationWith + '%');
      if (calcuationWith > 100) {
        const leftPosition = (calcuationWith - 100);
        const controlContainerWidth = 100 - leftPosition;
        $controlContainer.css('width', controlContainerWidth + '%');
        $controlContainer.css('left', leftPosition / 2 + '%');
      }
    } else {
      if (true) {
        $videoBgWidth.width(100 + '%');
      }
      $controlContainer.css('width', 100 + '%');
      $controlContainer.css('left', 0);
    }
  }

  checkIfPlaying() {
    if (!this.underPlay) {
      $('.play-next-wrapper').removeClass('hide');
    } else {
      $('body').removeClass('loading');
    }
  }

  onLoadVideo() {
    this.loadedPlay = true;
    const me = this;
    this.lastEvent = new Date().getTime();
    $('body').addClass('loading');

    const component = this.controller.getSectionComponents()[0]
    let vimeoId = component && component.properties && component.properties.vimeoId

    this.disableFullScreen = component && component.properties && component.properties.disableFullScreen == 'true'

    this.isReplay = this.controller.getAfterRewind() || this.controller.getPreviewing()

    this.videoVimeoId = vimeoId

    let content = $('<iframe id="vimeo_' + this.videoVimeoId + '" src="https://player.vimeo.com/video/' + this.videoVimeoId + '?api=1&controls=0&loop=0&autoplay=0&mute=0" style="visibility:hidden;" onload="this.style.visibility = \'visible\';" width="100%" height="100%;" frameborder="0" webkitallowfullscreen="true" mozallowfullscreen="true" allowfullscreen="true" allowTransparency="true" allow="autoplay"></iframe>');
    $('.videobg-hide-controls').html(content);
    let obj = this;
    this.player = new Player($("#vimeo_" + this.videoVimeoId));
    this.player.setVolume(1);
    this.player.on('timeupdate', (data) => {
      if (me.lastEvent && me.lastEvent < new Date().getTime() - 5000) {
        me.lastEvent = new Date().getTime();
        me.fadeOutControls();
      }

      data.duration = obj.duration;
      if (!obj.lastUpdated || obj.lastUpdated + obj.updateInterval < Date.now()) {
        obj.lastUpdated = Date.now()
        obj.onMediaTimeUpdate(data);
      }
    });
    this.player.on('loaded', (data) => {
      obj.player.getDuration().then(function (duration) {
        obj.onMediaTimeUpdate({ seconds: 0, percent: 0, duration: duration });
        $('body').removeClass('loading');
      }).catch(function (error) {
        // an error occurred
      });
    });
    setTimeout(() => {
      this.checkIfPlaying();
    }, 3000);
    this.player.on('ended', function (data) {
      obj.current = obj.duration;
      obj.onMediaEnd();
    });
  }



}
